/**
 * Reverses the HTML escaping the API applies to plain-text fields when saving,
 * e.g. a title typed as `Q&A` comes back from the API as `Q&amp;A`.
 *
 * Needed on every read path, not just for display: the admin form is populated
 * from the API response, so without decoding the already-escaped value would be
 * sent back and escaped again (`&amp;` -> `&amp;amp;`) on each save.
 *
 * `&amp;` is decoded last on purpose — decoding it first would turn a literal
 * `&amp;lt;` (a user who typed `&lt;`) into `<`.
 */
export function decodeHtmlEntities(value: string): string;
export function decodeHtmlEntities(value: string | null | undefined): string | null;
export function decodeHtmlEntities(value: string | null | undefined): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  return value
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&');
}
